import { sowAdminStoreKey } from './sow-admin.const';
import { AppStateWithAccountsData as State } from './sow-admin.types';

const select = (state: State) => state[sowAdminStoreKey];

export const getAccounts = (state: State) => select(state).accounts;
export const getProjects = (state: State) => select(state).projects;
export const getAccountsState = (state: State) => select(state).state;
export const getAccountsError = (state: State) => select(state).error;
export const getPortfolioAccounts = (state: State) =>
  select(state).portfolioAccounts;
export const getPortfolioProjects = (state: State) =>
  select(state).portfolioProjects;
export const getPortfolioAccountsState = (state: State) =>
  select(state).portfolioState;
export const getPortfolioAccountsError = (state: State) =>
  select(state).portfolioError;

export const getSowChangeReqs = (state: State) => select(state).sowChangeReqs;
export const getSowChangeReqStatuses = (state: State) =>
  select(state).sowChangeReqStatuses;
export const getDate = (state: State) => select(state).date;
export const getDateLocal = (state: State) => select(state).dateLocal;
export const getPortfolioDate = (state: State) => select(state).portfolioDate;
export const getPortfolioDateLocal = (state: State) =>
  select(state).portfolioDateLocal;
export const getIsUniqueFilterListsDefined = (state: State) =>
  select(state).isUniqueFilterListsDefined;
export const getUniqueFilterLists = (state: State) =>
  select(state).uniqueFilterLists;
export const getSowAdminFilters = (state: State) => select(state).filters;

export const getExecuteSowChangeReqState = (state: State) =>
  select(state).executeSowChangeReqState;
export const getExecuteSowChangeReqError = (state: State) =>
  select(state).executeSowChangeReqError;
export const getRejectSowChangeReqState = (state: State) =>
  select(state).rejectSowChangeReqState;
export const getRejectSowChangeReqError = (state: State) =>
  select(state).rejectSowChangeReqError;
export const getRequestMoveState = (state: State) =>
  select(state).requestMoveState;
export const getRequestMoveError = (state: State) =>
  select(state).requestMoveError;
export const getRequestEditState = (state: State) =>
  select(state).requestEditState;
export const getRequestEditError = (state: State) =>
  select(state).requestEditError;
export const getRequestDeactivateState = (state: State) =>
  select(state).requestDeactivateState;
export const getRequestDeactivateError = (state: State) =>
  select(state).requestDeactivateError;

export const sowAdminSelectors = {
  getDate,
  getDateLocal,
  getPortfolioDate,
  getPortfolioDateLocal,
  getAccounts,
  getProjects,
  getAccountsState,
  getAccountsError,
  getPortfolioAccounts,
  getPortfolioProjects,
  getPortfolioAccountsState,
  getPortfolioAccountsError,
  getSowChangeReqs,
  getSowChangeReqStatuses,
  getExecuteSowChangeReqState,
  getExecuteSowChangeReqError,
  getRejectSowChangeReqState,
  getRejectSowChangeReqError,
  getRequestMoveState,
  getRequestMoveError,
  getRequestEditState,
  getRequestEditError,
  getRequestDeactivateState,
  getRequestDeactivateError,
  getIsUniqueFilterListsDefined,
  getUniqueFilterLists,
  getSowAdminFilters,
};
